var _defs, _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2-1{fill:#dda63a;}.cls-2-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sdg2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-1",
    x: -0.61,
    y: -0.35,
    width: 51.07,
    height: 51.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-2",
    d: "M19.48,36.74v1a.44.44,0,0,0,.43.42H30.83a.44.44,0,0,0,.43-.44h0v-1A17,17,0,0,0,43,23.61v0a.36.36,0,0,0,0-.06.44.44,0,0,0-.44-.44H7.87a.44.44,0,0,0-.44.44l0,.2a17,17,0,0,0,12,13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-2",
    d: "M31.25,8.26c-.14.2-3.49,5,.07,8.93,1.64,1.79,1.49,3.37,1,4.44h2.29A5.63,5.63,0,0,0,33.06,16c-2.63-2.88,0-6.76.07-6.82a.86.86,0,0,0-.37-1.28,1.22,1.22,0,0,0-1.51.32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-2",
    d: "M25.45,21.63h2.29A5.63,5.63,0,0,0,26.16,16c-2.63-2.88,0-6.76.07-6.82a.86.86,0,0,0-.37-1.28,1.21,1.21,0,0,0-1.51.32c-.14.2-3.5,5,.07,8.93,1.64,1.79,1.49,3.37,1,4.44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-2",
    d: "M17.45,8.26c-.14.2-3.5,5,.07,8.93,1.64,1.79,1.5,3.37,1,4.44h2.29A5.63,5.63,0,0,0,19.25,16c-2.63-2.88,0-6.76.07-6.82A.86.86,0,0,0,19,7.95a1.21,1.21,0,0,0-1.51.32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdg2);
export default __webpack_public_path__ + "static/media/sdg2.803d3e92d5efd71472be61ad3503a9d2.svg";
export { ForwardRef as ReactComponent };